<template>
    <el-container id="app">
        <el-header>
            <a class="logo" href="/" title="前往首页">
                <img alt="" src="/favicon/android-chrome-512x512.png">
                <div class="text">山炮电商连锁</div>
            </a>
            <div class="nav">
                <template v-for="(nav,key) in navlist">
                    <template v-if="nav.to">
                        <router-link :key="key" :to="nav.to" class="link">{{nav.name}}</router-link>
                    </template>
                    <template v-else>
                        <el-link :href="nav.href" :key="key">{{nav.name}}</el-link>
                    </template>
                </template>
            </div>
            <div class="menu">
                <div @click="侧边菜单 = !侧边菜单" class="menu">
                    <i class="el-icon-s-fold"></i>
                </div>
            </div>
        </el-header>
        <el-main>
            <router-view/>
            <el-drawer
                    :size="'55%'"
                    :visible.sync="侧边菜单"
                    custom-class="task-cate"
                    direction="rtl">
                <div class="mobile-nav">
                    <template v-for="(nav,key) in navlist">
                        <template v-if="nav.to">
                            <router-link :key="key" :to="nav.to" class="link">{{nav.name}}</router-link>
                        </template>
                        <template v-else>
                            <el-link :href="nav.href" :key="key">{{nav.name}}</el-link>
                        </template>
                    </template>
                </div>
            </el-drawer>
        </el-main>
        <el-footer>
            &#169;深圳市山炮电子商务有限公司
            <a href="#">{{备案号}}</a>
        </el-footer>
    </el-container>

</template>
<script>
    import axios from 'axios'

    export default {
        name: 'app',
        data() {
            return {
                navlist: [
                    {
                        name: '首页',
                        to: '/',
                    },
                    // {
                    //     name: 'ERP',
                    //     href: 'http://erp.spg100.com',
                    // },
                    {
                        name: 'ERP2',
                        href: 'http://erp2.spg100.com',
                    }
                ],
                备案号: '粤ICP备200245100号-1',
                侧边菜单: false
            }
        },
        mounted() {
            //初始化VTS下载链接
            axios.get('http://39.98.156.250/vts2-android-version.json').then(response => {
                const version = response.data.version;
                if (!response.data.version) return;
                this.navlist.push({
                    name: `下载 ${version}`,
                    href: `http://39.98.156.250/${version}.apk`,
                })
            })
        }
    }
</script>

<style lang="scss">
    #app {
        height: 100vh;


        .el-header {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .logo {
                display: flex;
                align-items: center;
                text-decoration: none;

                img {
                    max-width: 50px;
                }

                .text {
                    margin-left: 20px;
                    letter-spacing: 2px;
                    font-size: 20px;
                    color: #233242;
                    font-weight: 600;
                    text-decoration: none;
                }
            }

            .nav {
                display: flex;
                align-items: center;

                .link {
                    margin: 0 20px;
                    text-decoration: none;
                    color: #233242;
                    font-size: 16px;
                    font-weight: 500;

                    position: relative;

                    &:hover {
                        color: #137eff;

                        &:after {
                            content: "";
                            position: absolute;
                            left: 0;
                            right: 0;
                            height: 0;
                            bottom: 0;
                            border-color: #137eff;
                            border-bottom: 1px solid #137eff;
                        }
                    }
                }

                .router-link-active {
                    color: #137eff;

                    &:after {
                        content: "";
                        position: absolute;
                        left: 0;
                        right: 0;
                        height: 0;
                        bottom: 0;
                        border-color: #137eff;
                        border-bottom: 1px solid #137eff;
                    }
                }

                .el-link {
                    margin: 0 20px;
                    font-size: 16px;
                }
            }

            .menu {
                display: none;
            }
        }

        .mobile-nav {
            display: flex;
            flex-direction: column;

            > a {
                height: 40px;
                padding: 10px 15px;
                color: #777777;
            }

            .el-link {
                justify-content: start;
            }
        }

        .el-main {
            width: 1200px;
            margin: 0 auto;
            min-height: calc(100% - 120px);
        }

        .el-footer {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #777777;
            background-color: #eeeeee;
            font-size: 14px;

            > a {
                margin-left: 15px;
                text-decoration: none;
                color: #777777;

                &:hover {
                    color: #333333;
                }
            }
        }
    }

    @media screen and (max-width: 800px) {
        #app {

            .el-header {
                width: 100%;
                flex-wrap: wrap;
                padding: 0 10px;

                .nav {
                    display: none;
                    flex-wrap: wrap;
                }

                .menu {
                    display: flex;
                    align-items: center;
                    width: 44px;
                    height: 34px;
                    border-radius: 5px;
                    font-size: 25px;
                    justify-content: center;
                    text-align: center;

                    &:hover {
                        background-color: #dddddd;
                    }
                }
            }

            .el-main {
                width: 100%;
            }

            .el-footer {
                flex-wrap: wrap;
            }
        }
    }
</style>
